import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import NoRecordFoundIcon from 'assets/images/icons/no-records-found.svg';
import DeleteConfirmation from 'ui-component/confirmation-dialogs/deleteConfirmation/DeleteConfirmation';
import { PiMicrosoftExcelLogoFill } from 'react-icons/pi';
import moment from 'moment';
import Filter from 'ui-component/filter-menu/Filter';
import { Skeleton, Tooltip } from '@mui/material';
import PermissionAllowed from 'ui-component/permissions/PermissionAllowed';
import usePermissions from 'hooks/usePermissions';
import usePageTitle from 'hooks/usePageTitle';
import { CommonDateOnlyFormat } from 'helpers/common.helper';
import CurrencyValue from 'ui-component/CurrencyValue';
import PreviewTransactionModal from './modals/PreviewTransactionModal';
import ExportTransactionModal from './modals/ExportTransactionModal';
import { FaSearch } from 'react-icons/fa';
import toast from 'react-hot-toast';
import {
    PreviewIcon,
    DeleteIcon,
} from 'ui-component/custom-icons/icons';
import { TbDatabaseExclamation } from 'react-icons/tb';
import useIsMobile from 'utils/isMobileUtils';
const index = () => {
    const [setPageTitle] = usePageTitle('Transactions');
    useEffect(() => {
        return () => {
            setPageTitle(null);
        };
    }, []);
    const history = useNavigate();
    const [allPermissions, hasEveryPermission] = usePermissions();
    const [isLoading, setIsLoading] = useState(false);
	const [openPreviewModal, setOpenPreviewModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [showDelete, setShowDelete] = useState(false);
    const [selectedForDelete, setSelectedForDelete] = useState(null);
    
    
    
	const [showExportModal, setShowExportModal] = useState(false);
    const [exportCompIsLoading, setExportCompIsLoading] = useState(false);
    
	const [searchField, setSearchField] = useState();
	const [searchValue, setSearchValue] = useState();
    const [searchTimeout, setSearchTimeout] = useState(null);
    const [filters, setFilters] = useState([]);
    const [activeFilters, setActiveFilters] = useState({});
    const [isFiltersloading, setIsFiltersloading] = useState(false);
    const [isFirstLoad, setIsFirstLoad] = useState(true);

    const handleClose = () => {
        setOpenPreviewModal(false);
        setSelectedRow(null)
        setShowDelete(false);
        setSelectedForDelete(null);
	};



    const getTransactions = () => {
        setIsLoading(true);
        api
            .getTransactionLists()
            .then((res) => {
                setIsLoading(false);
                isFirstLoad && setIsFirstLoad(false);
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Failed to fetch returns list:', error);
            });
    };

	const handleSearch = (e) => {
		

		let text = e.target.value;
		
		setIsLoading(true);
		setSearchValue(text);
		if (searchTimeout) {
			clearTimeout(searchTimeout);
		}

		// Only update searchField after user stops typing for 500ms
		let timeout = setTimeout(() => {
			setSearchField(text)	
		}, 500);

		setSearchTimeout(timeout);
	};




	const viewData = (type, id) => {
		if (type === 'contacts') {
			window.open(`/contacts/${id}`, '_blank');
		} else if (type === 'invoice') {
			window.open(`/sales/invoices/${id}`, '_blank');
		}
    };

    useEffect(() => {
        !isFirstLoad && handleFilter();
    }, [activeFilters]);

    const handleFilter = (activeF = null, searchF = null) => {
        setIsLoading(true);
        api.filterTransactions(activeFilters, searchField?.length > 2 ? searchField : null).then((res) => {
            setIsLoading(false);
        });
    };


    useEffect(() => {
        getTransactions();
        getFiltersList();
    }, []);

    const getFiltersList = () => {
        setIsFiltersloading(true);
        api.getTransactionFilter().then((res) => {
            setFilters(res.data);
            setIsFiltersloading(false);
        });
    };

    const handlePreviewTransaction = (id) => {
        setOpenPreviewModal(true);
        setSelectedRow(id);
    }


	const exportListSubmitHandler = (selectedValues) => {
        setExportCompIsLoading(true);
        
		api.exportTransaction(selectedValues).then((res) => {
            const filename = `Projectmix - Payment Transaction`;
			if (res != 404) {
				var newBlob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
				saveAs(newBlob, `${filename}.xlsx`);
				setExportCompIsLoading(false);
				toast.success('Downloaded Completed!');
				setShowExportModal(false);
			} else {
				setExportCompIsLoading(false);
				toast.error(res == 404 ? 'No Records Found!' : 'Download Failed!');
			}
		});
    };
    
    const deleteRecord = (data) => {
        setShowDelete(true);
        setSelectedForDelete(data);
    }

    const handleDelete = () => {
        setShowDelete(false);
        
        toast.promise(
            api.deleteTransaction(selectedForDelete?.id).then((res) => {
                if (res.status) {
					setIsLoading(true);
					setDataList([]);
					initializeData();
					getFiltersList();
                    // getTransactions();
                    setShowDelete(false);
                    setSelectedForDelete(null);
                }
                return res?.status ? res : abc;
            }),
            {
                loading: 'Deleting payment transaction...',
                success: (data) => `${data.message}`,
                error: <b>Failed to delete payment transaction</b>
            }
        );

    }
    const isMobile = useIsMobile()

	const [dataList, setDataList] = useState([]);
	const [page, setPage] = useState(1);
	const [hasMore, setHasMore] = useState(true);
	const tableRef = useRef();
	const [showPreloadingRows, setShowPreloadingRows] = useState(true);
	const [totalRecords, setTotalRecords] = useState(0);

	
	const [sortByFilter, setSortByFilter] = useState();



	const initializeData = () => {
		// Initial load
		let request = {}
		request.page = 1;
		request.search = searchField?.length > 2 ? searchField : null;
		
		
		api.getTransactionLists(request, activeFilters, searchField, sortByFilter).then((res) => {
			setDataList([]);
			setTimeout(() => {
				setDataList(res?.data?.data?.data || []);

				setHasMore(true);
				setPage(1);
				setIsLoading(false);
				setShowPreloadingRows(false);
				setTotalRecords(res?.data?.data?.total || 0);
			}, 300);
		});

	}




	useEffect(() => {
		// Only run fetchData after user stops typing (debounced by searchTimeout)
		// setIsLoading(true);
		if (searchTimeout) {
			clearTimeout(searchTimeout);
		}

		const timeout = setTimeout(() => {
			const fetchData = async () => {
				// if (searchField) {
					await handleSearch({ target: { value: searchField } });
				// }
				setDataList([]);
				initializeData();
				getFiltersList();
			};
			fetchData();
		}, 500); // 500ms debounce

		setSearchTimeout(timeout);

		// Cleanup on unmount or before next effect run
		return () => clearTimeout(timeout);
		// Only trigger when these change
	}, [searchField, activeFilters]);


	useEffect(() => {
		setIsLoading(true);
	}, [activeFilters])


	useEffect(() => {
		const handleScroll = () => {
			if (!tableRef.current || showPreloadingRows || !hasMore) return;
			const { scrollTop, scrollHeight, clientHeight } = tableRef.current;
			// Trigger only when user reaches the bottom (with a small threshold)
			if (scrollTop + clientHeight >= scrollHeight - 10) {
				loadMoreData();
			}
		};
		const currentRef = tableRef.current;
		if (currentRef) {
			currentRef.addEventListener('scroll', handleScroll);
		}
		return () => {
			if (currentRef) {
				currentRef.removeEventListener('scroll', handleScroll);
			}
		};
	}, [showPreloadingRows, hasMore, dataList]);

    const loadMoreData = () => {
        if (showPreloadingRows || !hasMore) return;
        setShowPreloadingRows(true);
        let request = {};
        request.page = page + 1;
        request.search = searchField?.length > 2 ? searchField : null;

        
        api.getTransactionLists(request, activeFilters, searchField, sortByFilter).then((res) => {
            // Use pagination meta from backend
            const nextPage = res?.data?.data?.meta?.current_page || request.page;
            const lastPage = res?.data?.data?.meta?.last_page || nextPage;
            if (nextPage > lastPage || res?.data?.data?.data?.length === 0) {
                setHasMore(false);
            } else {
                setDataList(prev => [...prev, ...res?.data?.data?.data || []]);
                setPage(nextPage);
            }
            setShowPreloadingRows(false);
        });
    };



    return (
		<>
			<div className="row">
				{/* Area Chart */}
				<div className="col-xl-12 col-lg-12">
					<div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
						<div className="header-bubble" />
						<div className="d-flex flex-column gap-2 " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
							<h5 style={{ textAlign: 'center' }}>Payment Transactions</h5>
							<div
								style={{
									paddingLeft: 20,
									paddingRight: 20,
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
									gap: 10,
									paddingBottom: 4
								}}
							>
								<PermissionAllowed permissions={['Export Payment Transaction']}>
									<button
										className="btn btn-primary btn-outlined-main white-var btn-create-report"
										onClick={() => {
											setShowExportModal(true);
										}}
									>
										<PiMicrosoftExcelLogoFill style={{ fontSize: '1.4em' }} /> Export
									</button>
								</PermissionAllowed>
							</div>
						</div>
					</div>
					<div className="section-head-new hide-on-mobile" style={{ margin: '10px 0', paddingLeft: '0' }}>
						<div className="actions">
							<PermissionAllowed permissions={['Export Payment Transaction']}>
								<button
									className="btn btn-primary btn-outlined-main white-var btn-create-report"
									onClick={() => {
										setShowExportModal(true);
									}}
								>
									<PiMicrosoftExcelLogoFill style={{ fontSize: '1.4em' }} /> Export
								</button>
							</PermissionAllowed>
						</div>
					</div>
					<div
						style={{
							justifyContent: 'space-between',
							alignItems: 'center',
							gap: 10,
							paddingLeft: '20px',
							paddingRight: 20,
							paddingBottom: 5
						}}
						className="show-on-mobile"
					>
						<form className="form-inline navbar-search" style={{ flex: 1 }}>
							<div style={{ position: 'relative', width: '100%' }}>
								<input
									type="text"
									className="form-control bg-white border"
									placeholder="Search"
									aria-label="Search"
									aria-describedby="basic-addon2"
									value={searchValue || ''}
									onChange={handleSearch}
									style={{ width: '100%' }}
								/>
								<span
									className="searchIcon"
									style={{
										position: 'absolute',
										right: 10,
										top: '50%',
										transform: 'translateY(-50%)',
										color: '#888',
										pointerEvents: 'none'
									}}
								>
									<FaSearch />
								</span>
							</div>
						</form>
						<div style={{ flexShrink: 0 }}>
							<Filter activeFilters={activeFilters} onSubmit={setActiveFilters} filters={filters} />
						</div>
					</div>
					<div className={`card shadow-sm  bg-white mb-4 table-card ${isMobile ? 'shorter-table' : ''}`} style={{ overflowY: 'auto' }}>
						<div className=" align-items-center justify-content-between TableSerachBar">
							<div>
								<div className="actions" style={{ display: 'flex', width: '100%' }}>
									<div style={{ margin: '0 5px' }}>
										<Filter activeFilters={activeFilters} onSubmit={setActiveFilters} filters={filters} />
									</div>
								</div>
							</div>
							<form className="form-inline navbar-search" onSubmit={(e) => e.preventDefault()}>
								<div className="input-group">
									<input
										type="text"
										className="form-control bg-white border"
										placeholder="Search"
										aria-label="Search"
										aria-describedby="basic-addon2"
										value={searchValue || ''}
										onChange={handleSearch}
										style={{ width: '100%' }}
									/>
									<span className="searchIcon">
										<FaSearch />
									</span>
								</div>
							</form>
						</div>
					
					{!isMobile ? (

						<div
							className="table-responsive-xl tableData estimationList"
							ref={tableRef}
							style={{
								height: 'calc(100vh - 260px)',
								overflowY: 'auto',
								scrollbarWidth: 'thin',
								scrollbarColor: '#0966ff transparent'

							}}
						>
							<table className="table pm-table">
								<thead>
									<tr className="sticky-header">
										<th scope="col">Client</th>
										<th scope="col text-left">Invoice</th>
										<th scope="col text-left">Transaction Type</th>
										<th scope="col text-left">Amount</th>
										<th scope="col text-left">Date</th>

										<PermissionAllowed permissions={['Delete Payment Transaction']}>
											<th scope="col" className="text-center" style={{ width: '5%' }}>
												Action
											</th>
										</PermissionAllowed>
									</tr>
								</thead>
								<tbody>
									{isLoading ? (
										[...Array(50)].map((e, i) => (
											<tr>
												{[...Array(6)].map((e, i) => (
													<td>
														<Skeleton variant="rounded" width={'100%'} height={20}></Skeleton>
													</td>
												))}
											</tr>
										))
									) : (
										<>

											{dataList?.length > 0 && (
												dataList?.map((row, index) => {
													return (
														<tr key={index} style={{ height: '35px' }}>
															<td
																className={
																	hasEveryPermission(['View Contact (Button)'])
																		? 'cursor-pointer text-primary align-middle font14'
																		: 'align-middle font14'
																}
																onClick={() => {
																	if (hasEveryPermission(['View Contact (Button)'])) {
																		if (row?.estimation?.transit_company?.name) {
																			viewData('contacts', row?.estimation?.transit_company?.id);
																		} else if (row?.estimation?.customer?.name) {
																			viewData('contacts', row?.estimation?.customer?.id);
																		}
																	}
																}}
															>
																{row?.estimation?.transit_company?.name ? (
																	<div>{row?.estimation?.transit_company?.name}</div>
																) : row?.estimation?.customer?.name ? (
																	<div>{row?.estimation?.customer?.name}</div>
																) : (
																	<></>
																)}
															</td>
															<td
																className={
																	hasEveryPermission(['View Estimation Details (Page)'])
																		? 'cursor-pointer text-primary align-middle font14'
																		: 'align-middle font14'
																}
																onClick={() => {
																	if (hasEveryPermission(['View Estimation Details (Page)'])) {
																		if (row?.estimation?.invoice_number) {
																			viewData('invoice', row?.estimation?.id);
																		}
																	}
																}}
															>
																<div>{row?.estimation?.invoice_number}</div>
															</td>
															<td className="align-middle font14">{row?.payment_type}</td>
															<td className="align-middle font14">
																<CurrencyValue currencyObject={row?.converted_price} defaultCurrency={row?.currency} />
															</td>
															<td className="align-middle font14">{moment(row?.payment_date).format(CommonDateOnlyFormat)}</td>
															<PermissionAllowed
																permissions={['Delete Payment Transaction', 'Preview Payment Transaction Details']}
																hasSome
															>
																<td className="align-middle  font14">
																	<div className="action-col">
																		<PermissionAllowed permissions={['Preview Payment Transaction Details']} hasSome>
																			<Tooltip title={'Preview'} arrow placement="top">
																				<a
																					href="javascript:void(0);"
																					onClick={() => {
																						if (hasEveryPermission(['Preview Payment Transaction Details'])) {
																							handlePreviewTransaction(row?.id);
																						}
																					}}
																				>
																					<PreviewIcon height={'18px'} width={'18px'} />
																				</a>
																			</Tooltip>
																		</PermissionAllowed>
																		<PermissionAllowed permissions={['Delete Payment Transaction']} hasSome>
																			<Tooltip title={'Delete'} arrow placement="top">
																				<a
																					href="javascript:void(0);"
																					onClick={() => {
																						if (hasEveryPermission(['Delete Payment Transaction'])) {
																							deleteRecord(row);
																						}
																					}}
																					style={{ marginLeft: '3px' }}
																					className="text-danger"
																				>
																					<DeleteIcon height={'16px'} width={'16px'} />
																				</a>
																			</Tooltip>
																		</PermissionAllowed>
																	</div>
																</td>
															</PermissionAllowed>
														</tr>
													)
												})
											)}
											{showPreloadingRows && (
												[...Array(100)].map((e, i) => (
													<tr>
														{[...Array(6)].map((e, i) => (
															<td>
																<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
															</td>
														))}
													</tr>
												))
											)}
											{(dataList?.length < 1 && !isLoading) && (
												<tr className="no-hover">
													<td colSpan={6} className="whitebg">
														<div className="not-found-container">
															<div className="not-found-icon">
																<img src={NoRecordFoundIcon} style={{ height: '200px', width: '200px' }} />
															</div>
															<h6 className="not-found-text">No Data Available</h6>
														</div>
													</td>
												</tr>
											)}
										</>
									)}
								</tbody>
							</table>
						</div>
					) : (
						<div
							className="picklists-mobile-list"
							ref={tableRef}
							style={{
								height: `calc(100dvh - ${Object.keys(activeFilters).length === 0 ? '305px' : '332px' })`,
								overflowY: 'auto',
								display: 'flex',
								flexDirection: 'column'
							}}
						>
							{isLoading ? (
								[...Array(7)].map((_, i) => (
									<div className="inv-cards-list d-md-none" style={{ padding: '12px 0' }}>
										{[...Array(15)].map((_, idx) => (
											<div
												key={idx}
												className="order-list-card"
												style={{
													background: idx % 2 === 0 ? '#f9f9f9' : '#fff',
													marginBottom: 10,
													borderRadius: 12,
													padding: 16,
													minHeight: 90,
													display: 'flex',
													flexDirection: 'column',
													gap: 10
												}}
											>
												{[...Array(3)].map((__, i) => (
													<div key={i} style={{ width: i === 0 ? '60%' : i === 1 ? '40%' : '80%' }}>
														<Skeleton variant="rounded" width={'100%'} height={18} style={{ borderRadius: '8px' }} />
													</div>
												))}
											</div>
										))}
									</div>
								))
							) : (
								<>
									{dataList.map((row, index) => (
										<div
											style={{
												display: 'flex',
												padding: '5px 20px',
												flexDirection: 'row',
												background: index % 2 === 0 ? '#f9f9f9' : '#fff',
												borderBottom: '1px solid #eee',
												justifyContent: 'space-between'
											}}
											key={row.id || index}
											onClick={() => {
												if (hasEveryPermission(['Preview Payment Transaction Details'])) {
													handlePreviewTransaction(row?.id);
												}
											}}
										>
											<div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center', gap: 10 }}>
												<div style={{ display: 'flex', flexDirection: 'column', gap: 5, width: '100%' }}>
													<div style={{ display: 'flex', gap: 5, fontWeight: 500 }}>
														<div>Invoice #:</div>
														<div
															className=""
															//
															style={{
																cursor: hasEveryPermission(['View Picklists (Button)']) ? 'pointer' : 'not-allowed',
																color: '#316aff'
															}}
														>
															{row?.estimation?.invoice_number}
														</div>
													</div>
													<div
														className="picklist-mobile-row"
														style={{
															cursor: hasEveryPermission(['View Picklists (Button)']) ? 'pointer' : 'not-allowed'
														}}
													>
														{row?.estimation?.transit_company?.name ? (
															<>
																<div className="">Transit:</div>
																<div>{row?.estimation?.transit_company?.name}</div>
															</>
															
														) : row?.estimation?.customer?.name ? (
															<>
																<div className="">Customer:</div>
																<div>{row?.estimation?.customer?.name}</div>
															</>
														) : (
															''
														)}
													</div>
													<div
														className="picklist-mobile-row"
														style={{
															cursor: hasEveryPermission(['View Picklists (Button)']) ? 'pointer' : 'not-allowed'
														}}
													>
														<div>Type:</div>
														<div >
															{row?.payment_type}
														</div>
													</div>
												</div>
												<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
													<div style={{ width: '100px' }}>
														<div>{moment(row?.payment_date).format(CommonDateOnlyFormat)}</div>
													</div>
													<div>
														<div >
															<CurrencyValue currencyObject={row?.converted_price} defaultCurrency={row?.currency} />
														</div>
													</div>
													<div style={{ height: '17px' }}></div>
												</div>
											</div>
										</div>
									))}
									
									{showPreloadingRows && (
										[...Array(100)].map((_, idx) => (
											<div
												key={idx}
												className="order-list-card"
												style={{
													background: idx % 2 === 0 ? '#f9f9f9' : '#fff',
													marginBottom: 10,
													borderRadius: 12,
													padding: 16,
													minHeight: 90,
													display: 'flex',
													flexDirection: 'column',
													gap: 10
												}}
											>
												{[...Array(3)].map((__, i) => (
													<div key={i} style={{ width: i === 0 ? '60%' : i === 1 ? '40%' : '80%' }}>
														<Skeleton variant="rounded" width={'100%'} height={18} style={{ borderRadius: '8px' }} />
													</div>
												))}
											</div>
										))
									)}
									{(dataList?.length < 1 && !isLoading) && (
										<div className="w-100">
											<div className="not-found-container">
												<div className="not-found-icon">
													<TbDatabaseExclamation />
												</div>
												<h6 className="not-found-text">No Data Available</h6>

												<PermissionAllowed permissions={['Create Operation']}>
													<Link to={'/opearations/create'} className="btn btn-primary btn-outlined-main">
														Create Operation
													</Link>
												</PermissionAllowed>
											</div>
										</div>
									)}
								</>
							)}
						</div>
					)}
					
						<div
							className="hide-on-mobile"
							style={{
								padding: '10px 0px 10px 20px',
								borderTop: '1px solid #e0e0e0e0',
								display: 'flex',
								gap: '5px',
								justifyContent: 'space-between',
								height: '45px',
							}}
						>

							<div className="flex align-items-center" style={{ gap: '10px' }}>
								
							</div>
							<div className="flex align-items-center ml-auto" style={{ gap: '5px', paddingRight: '25px' }}>
								{isLoading ? (
									<div style={{ width: '100px' }}>
										<Skeleton variant="rounded" width={'100%'} height={20}></Skeleton>
									</div>
								) : (
									<>
										<div className="text-gray-800">Total Record:</div>
										<div className="fw-500">
												{totalRecords.toLocaleString('en-US')}
										</div>
									</>
								)}
							</div>
						</div>

					</div>
				</div>
			</div>

			{openPreviewModal && <PreviewTransactionModal openPopup={openPreviewModal} selectedRow={selectedRow} handleClose={handleClose} />}

			{showExportModal && (
				<ExportTransactionModal
					openpopup={true}
					disablepopup={() => {
						setShowExportModal(false);
					}}
					filters={filters}
					moduleName={'Orders'}
					onSubmit={exportListSubmitHandler}
					isLoading={exportCompIsLoading}
				/>
			)}

			{showDelete && (
				<DeleteConfirmation
					show={showDelete}
					handleClose={handleClose}
					handleDelete={handleDelete}
					title="Confirm"
					message={`Are you sure you want to delete <br />transaction #${selectedForDelete?.reference_number}?`}
				/>
			)}
		</>
	);
};

export default index;
